import axios from 'axios'
import { resolveApiBaseUrl } from '@/services/apiConfig'
import { secureStorage } from '@/services/secureStorage'

const apiBaseUrl = resolveApiBaseUrl()

const client = axios.create({
  baseURL: apiBaseUrl,
})

const authHeader = () => {
  const token = secureStorage.getItem('setIn')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchNotifications({ page = 1, perPage = 10, status } = {}) {
  const params = { page, per_page: perPage }
  if (status) params.status = status
  const { data } = await client.get('/notifications', { params, headers: authHeader() })
  return normalizeListResponse(data)
}

export async function markRead(id) {
  if (!id) return
  const { data } = await client.post(`/notifications/${id}/read`, {}, { headers: authHeader() })
  return data
}

export async function markBulk(ids = []) {
  if (!ids.length) return
  const { data } = await client.post('/notifications/read-bulk', { ids }, { headers: authHeader() })
  return data
}

export async function markAll() {
  const { data } = await client.post('/notifications/read-all', {}, { headers: authHeader() })
  return data
}

export async function deleteNotification(id) {
  if (!id) return
  const { data } = await client.post(`/notifications/${id}/delete`, {}, { headers: authHeader() })
  return data
}

export async function deleteBulk(ids = []) {
  if (!ids.length) return
  const { data } = await client.post('/notifications/delete-bulk', { ids }, { headers: authHeader() })
  return data
}

export async function createNotification(payload) {
  const { data } = await client.post('/notifications', payload, { headers: authHeader() })
  return data
}

function normalizeListResponse(raw) {
  if (!raw) return []
  // Laravel paginator => { data: [...], meta: {...} }
  if (Array.isArray(raw.data)) {
    const meta = raw.meta || buildMetaFromPaginator(raw)
    return { data: raw.data, meta }
  }
  // Direct array
  if (Array.isArray(raw)) {
    return { data: raw, meta: {} }
  }
  // Object keyed by index
  if (typeof raw === 'object') {
    const values = Object.values(raw)
    return { data: values, meta: {} }
  }
  return { data: [], meta: {} }
}

function buildMetaFromPaginator(raw = {}) {
  // Fallback when backend sends paginator keys at the root
  const {
    current_page,
    last_page,
    per_page,
    total,
    from,
    to
  } = raw

  if (
    current_page === undefined &&
    last_page === undefined &&
    per_page === undefined &&
    total === undefined
  ) {
    return {}
  }

  return {
    current_page,
    last_page,
    per_page,
    total,
    from,
    to
  }
}
